import Plotly from 'plotly.js/dist/plotly.min.js';

export default {
    init() {
        // JavaScript to be fired on the source of growth template

        // GENERATE THE GRAPH
        (function(){
            let q1HoldInput;
            let q1DeepenInput;
            let q1DisplaceInput;
            let q1PenetrateInput;
            let q2HoldInput;
            let q2DeepenInput;
            let q2DisplaceInput;
            let q2PenetrateInput;


            function createResponsiveChart(q1HoldInput, q1DeepenInput, q1DisplaceInput, q1PenetrateInput, q2HoldInput, q2DeepenInput, q2DisplaceInput, q2PenetrateInput) {
                var tValue = ['HOLD', 'DEEPEN', 'DISPLACE', 'PENETRATE', 'HOLD'];

                var q1Value = [q1HoldInput, q1DeepenInput, q1DisplaceInput, q1PenetrateInput, q1HoldInput];
                var q2Value = [q2HoldInput, q2DeepenInput, q2DisplaceInput, q2PenetrateInput, q2HoldInput];

                // Calculate the total values for both yValue and yValue2
                var totalValue = q1Value.reduce(function(sum, value) {
                    return sum + value;
                }, 0);

                var totalValue2 = q2Value.reduce(function(sum, value) {
                    return sum + value;
                }, 0);
                
                // Convert the yValue and yValue2 arrays to percentages
                q1Value = q1Value.map(function(value) {
                    return (value / totalValue) * 100;
                });

                q2Value = q2Value.map(function(value) {
                    return (value / totalValue2) * 100;
                });
                
                var trace1 = {
                    type: 'scatterpolar',
                    r: q1Value,
                    theta: tValue,
                    name: 'REVENUE',
                    line: { color: 'blue' },
                };
                
                var trace2 = {
                    type: 'scatterpolar',
                    r: q2Value,
                    theta: tValue,
                    name: 'EFFORT',
                    line: { color: 'red' },
                };
                
                var data = [trace1, trace2];
                
                var layout = {
                    // width: 800,
                    // height: 600,
                    polar: {
                        radialaxis: {
                          visible: true,
                        },
                        angularaxis: {
                            visible: true,
                            direction: 'clockwise',
                            rotation: 90,
                        },
                    },
                    paper_bgcolor: 'rgba(0,0,0,0)',
                    plot_bgcolor: 'rgba(0,0,0,0)',
                };

                const config = {
                    displayModeBar: false,
                };
                
                Plotly.newPlot('jsSOGChart', data, layout, config);
            }

            function getSuggestion() {
                const ratios = {
                    Hold: q1HoldInput / q2HoldInput,
                    Deepen: q1DeepenInput / q2DeepenInput,
                    Displace: q1DisplaceInput / q2DisplaceInput,
                    Penetrate: q1PenetrateInput / q2PenetrateInput,
                };
            
                const isAnyNan = Object.values(ratios).some((ratio) => isNaN(ratio));
            
                if (!isAnyNan) {
                    const sortedRatios = Object.entries(ratios)
                        .sort(([, a], [, b]) => b - a)
                        .map(([key]) => key);

                    // Access the first and second items
                    const firstItem = sortedRatios[0];
                    const secondItem = sortedRatios[1];

                    // Update the HTML
                    const focusSuggestion = document.getElementById('focusSuggestion');
                    if (focusSuggestion) {
                        // Create a text with the first and second items and set it to the div's innerHTML                        
                        focusSuggestion.innerHTML = `Focus on '<strong>${firstItem}</strong> and <strong>${secondItem}'</strong>, <br>and decide on the third priority after additional analysis or discussion.`;
                    } else {
                        console.error('Element with ID "focusSuggestion" not found.');
                    }
                }
            }
            

            // Initial chart creation
            createResponsiveChart(q1HoldInput, q1DeepenInput, q1DisplaceInput, q1PenetrateInput, q2HoldInput, q2DeepenInput, q2DisplaceInput, q2PenetrateInput);

            // Function to update chart on window resize
            function updateChart() {
                Plotly.purge('jsSOGChart');
                createResponsiveChart(q1HoldInput, q1DeepenInput, q1DisplaceInput, q1PenetrateInput, q2HoldInput, q2DeepenInput, q2DisplaceInput, q2PenetrateInput);
            }

            // Listen for window resize events and update the chart accordingly
            window.addEventListener('load', updateChart); 
            window.addEventListener('resize', updateChart);  

            const percentInputs = document.querySelectorAll('.percent-input');
            let q1InputTotal = 0;
            let q2InputTotal = 0;

            function updateInputsTotal(input, q) { 
                if(q === 'q1') {                    
                    const q1Inputs = document.querySelectorAll('input[name="question1"]');

                    q1InputTotal = q1HoldInput + q1DeepenInput + q1DisplaceInput + q1PenetrateInput;

                    if (q1InputTotal > 100) {
                        q1Inputs.forEach(input => input.classList.add('is-invalid'));
                        document.getElementById('q1MessageBox').classList.remove('d-none');
                    } else {
                        q1Inputs.forEach(input => input.classList.remove('is-invalid'));
                        document.getElementById('q1MessageBox').classList.add('d-none');
                    }
                }

                if(q === 'q2') {                    
                    const q2Inputs = document.querySelectorAll('input[name="question2"]');

                    q2InputTotal = q2HoldInput + q2DeepenInput + q2DisplaceInput + q2PenetrateInput;

                    if (q2InputTotal > 100) {
                        q2Inputs.forEach(input => input.classList.add('is-invalid'));
                        document.getElementById('q2MessageBox').classList.remove('d-none');
                    } else {
                        q2Inputs.forEach(input => input.classList.remove('is-invalid'));
                        document.getElementById('q2MessageBox').classList.add('d-none');
                    }
                }
            }

            percentInputs.forEach(function(input) {
              
                const resetButton = input.nextElementSibling;

                resetButton.addEventListener('click', function() {
                    input.value = 0;

                    // Create and dispatch an 'input' event
                    const inputEvent = new Event('input', { bubbles: true, cancelable: true });
                    input.dispatchEvent(inputEvent);
                });  

                input.addEventListener('input', function() {
                    // Remove any non-digit characters
                    let inputValue = input.value.replace(/\D/g, '');
            
                    // Limit the input value to a range between 0 and 100
                    if (inputValue < 1) {
                        inputValue = 0;
                    } else if (inputValue > 100) {
                        inputValue = 100;
                    }
            
                    // Add a percentage sign to the input value
                    input.value = inputValue + '%';
            
                    // Update the corresponding input variable
                    switch (input.id) {
                        case 'q1HoldInput': 
                            q1HoldInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q1');
                            break;
                        case 'q1DeepenInput': 
                            q1DeepenInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q1');
                            break;
                        case 'q1DisplaceInput': 
                            q1DisplaceInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q1');
                            break;
                        case 'q1PenetrateInput': 
                            q1PenetrateInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q1');
                            break;
                        case 'q2HoldInput': 
                            q2HoldInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q2');
                            break;
                        case 'q2DeepenInput': 
                            q2DeepenInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q2');
                            break;
                        case 'q2DisplaceInput': 
                            q2DisplaceInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q2');
                            break;
                        case 'q2PenetrateInput': 
                            q2PenetrateInput = parseInt(inputValue,10); 
                            updateInputsTotal(input, 'q2');
                            break;
                        default:
                            // Handle any other cases if needed
                    }

                    getSuggestion();
            
                    // Trigger the chart update only if the input value has changed                    
                    updateChart();
                });
            });

        })();

        // GENERATE THE PDF DOWNLOAD
        (function(){
            document.getElementById('downloadPdfButton').addEventListener('click', function() {
                generatePDF();
            });
            
            function generatePDF() {
                Plotly.toImage('jsSOGChart', {format: 'png', width: 800, height: 600}).then(function(dataUrl) {

                    var docDefinition = {
                        content: [           
                            {
                                image: 'data:image/png;base64,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',
                                link: 'https://insideoutgroup.com.au',
                                width: 150,
                                alignment: 'center',
                                margin:[0,0,0,50],
                            },
                            {
                                text: 'Source of Growth',
                                fontSize: 40,                                
                                bold: true,
                                alignment: 'center',
                                margin: [0, 0, 0, 50],
                                color: '#0daf4b',
                            },
                            { image: dataUrl, width: 500 },          
                        ],
                        fonts: {
                            normal: 'Roboto-Regular.ttf',
                            bold: 'Roboto-Medium.ttf',
                        },
                        styles: {
                            header: {
                                fontSize: 12,
                                bold: true,
                                font : 'Roboto',
                                margin: [0, 20, 0, 10],
                            },
                        },
                    };
            
                    // eslint-disable-next-line
                    pdfMake.fonts = {
                        Roboto: {
                            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.4/fonts/Roboto/Roboto-Regular.ttf',
                            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.4/fonts/Roboto/Roboto-Medium.ttf',
                            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.4/fonts/Roboto/Roboto-Italic.ttf',
                            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.4/fonts/Roboto/Roboto-MediumItalic.ttf',
                        },
                    };
            
                    // eslint-disable-next-line
                    pdfMake.createPdf(docDefinition).download('iog-source-of-growth.pdf');
                });
            }

        })();

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/sog.js